import { FC, useContext } from "react";
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { KeyPointsFlyout } from "@app/projects/network-assessment/provider-hub/contract-entity-profile/KeyPointsFlyout";
import { AccessGapTypeEnum } from "@app/projects/network-assessment/provider-hub/enumerators";
import { GapRegionStatusAnnotation } from "@app/projects/network-assessment/provider-hub/GapRegionStatusAnnotation";
import { QESButtonTypeClasses } from "@app/shared/qes-standards/Button";

export const OrganizationProfileKeyPoints: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedOrganization } = providerHubContext;
  const providerCount = providerHubContext.selectedOrganization.servicingProviders;
  const specialtyCount = providerHubContext.selectedOrganization.servicingSpecialties;

  return (
    <div className="provider-profile__card">
      <h4 className="provider-profile__card-title">Key Points</h4>
      <div className="provider-profile__card-content">
        <div className="provider-profile__card-values">
          <div className="provider-profile__card-highlight" aria-labelledby="providers">{providerCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="specialties">{specialtyCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="closes-gaps">
            {!selectedOrganization.gapsClosed 
              ? (selectedOrganization.gapsClosed === 0 ? selectedOrganization.gapsClosed : "---")
                : (<FlyoutLink
                      classNames={QESButtonTypeClasses.get("link")}
                      testId="provider-profile__closes-gaps"
                      content={{
                        body: <KeyPointsFlyout gapType={AccessGapTypeEnum.FillableBySingleProvider} />,
                        title: "Gap Closure"
                      }}>
                        {selectedOrganization.gapsClosed}
                    </FlyoutLink>)
            }
            <GapRegionStatusAnnotation
              total={selectedOrganization.gapsClosed}
              active={selectedOrganization.activeGapsClosed}
              pending={selectedOrganization.pendingGapsClosed}
              approved={selectedOrganization.approvedGapsClosed}
              opportunity={selectedOrganization.opportunityGapsClosed}
              useGapsByRegionStatus={selectedOrganization.useGapsByRegionStatus}
            />
          </div>
        </div>

        <div className="provider-profile__card-labels">
          <div className="provider-profile__card-subtitle" id="providers">Providers</div>
          <div className="provider-profile__card-subtitle" id="specialties">Specialty Groups</div>
          <div className="provider-profile__card-subtitle" id="closes-gaps">Closes Gaps</div>
        </div>
      </div>
    </div>
  );
};